var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 118,
    viewBox: "0 0 89 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6859 44.2158H10.1697C8.58816 44.2158 7.07214 44.8437 5.9535 45.9623C4.83685 47.079 4.20898 48.595 4.20898 50.1766V62.0981H83.6859V44.2158Z",
    fill: "#A4BBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20898 51.54H83.6859V55.2417H4.20898V51.54Z",
    fill: "#8DA3BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6845 42.3856C83.6845 40.806 83.0566 39.2899 81.938 38.1713C80.8194 37.0547 79.3033 36.4248 77.7237 36.4248C70.6086 36.4248 58.8877 36.4248 52.613 36.4248C50.0558 36.4248 47.7848 38.0561 46.9662 40.4781C45.8177 43.8817 44.3613 48.1894 44.3613 48.1894H83.6845V42.3856Z",
    fill: "#A4BBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6282 63.324C88.9858 61.0311 88.3222 58.6945 86.8121 56.9301C85.302 55.1657 83.0966 54.1504 80.7738 54.1504C63.2472 54.1504 25.4758 54.1504 7.9492 54.1504C5.62648 54.1504 3.421 55.1657 1.91094 56.9301C0.400882 58.6945 -0.262751 61.0311 0.0948946 63.324C2.11758 76.2628 5.75762 99.5615 7.54585 111.01C8.15186 114.881 11.4839 117.732 15.4002 117.732H73.3229C77.2391 117.732 80.5712 114.881 81.1772 111.01C82.9654 99.5615 86.6055 76.2628 88.6282 63.324Z",
    fill: "#CADCF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0948946 63.324L1.11419 69.8411C0.754554 67.5462 1.54336 65.2096 3.05342 63.4452C4.56348 61.6808 6.76896 60.6655 9.09168 60.6655H79.6314C81.9541 60.6655 84.1596 61.6808 85.6696 63.4452C87.1797 65.2096 87.9685 67.5462 87.6089 69.8411L88.6282 63.324C88.9858 61.0311 88.3222 58.6945 86.8121 56.9301C85.302 55.1657 83.0966 54.1504 80.7738 54.1504C63.2472 54.1504 25.4758 54.1504 7.9492 54.1504C5.62648 54.1504 3.421 55.1657 1.91094 56.9301C0.400882 58.6945 -0.262751 61.0311 0.0948946 63.324Z",
    fill: "#E9F3FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8235 101.533C39.8235 99.3399 38.0452 97.5596 35.8497 97.5596C31.4407 97.5596 24.3653 97.5596 19.9543 97.5596C17.7608 97.5596 15.9805 99.3399 15.9805 101.533V105.507C15.9805 107.703 17.7608 109.481 19.9543 109.481H35.8497C38.0452 109.481 39.8235 107.703 39.8235 105.507C39.8235 104.23 39.8235 102.813 39.8235 101.533Z",
    fill: "#347BFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5875 46.6197C27.5001 46.0594 27.4584 45.5071 27.4604 44.9627C27.4643 43.8679 26.5782 42.9737 25.4814 42.9678C24.3846 42.9638 23.4905 43.85 23.4865 44.9468C23.4825 45.6978 23.5402 46.4628 23.6634 47.2377C23.8322 48.3206 24.8515 49.0617 25.9344 48.8908C27.0173 48.7219 27.7584 47.7026 27.5875 46.6197Z",
    fill: "#347BFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6757 39.0033C30.0652 38.5463 30.5023 38.1172 30.9871 37.7158C31.8315 37.0164 31.9507 35.7646 31.2513 34.9182C30.5519 34.0738 29.3002 33.9546 28.4538 34.654C27.7881 35.2043 27.1861 35.7984 26.6496 36.4263C25.9383 37.2628 26.0396 38.5165 26.8742 39.2279C27.7087 39.9392 28.9644 39.8378 29.6757 39.0033Z",
    fill: "#347BFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1633 34.8488C37.966 34.668 38.8124 34.5329 39.7006 34.4435C40.7914 34.3342 41.5882 33.3606 41.4789 32.2698C41.3696 31.179 40.396 30.3802 39.3052 30.4895C38.2521 30.5948 37.2467 30.7577 36.293 30.9723C35.2221 31.2127 34.5485 32.2757 34.7889 33.3447C35.0293 34.4157 36.0923 35.0892 37.1633 34.8488Z",
    fill: "#347BFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3343 34.4359C48.5464 34.4677 49.6968 34.4578 50.7936 34.4121C51.8884 34.3664 52.7408 33.4385 52.6951 32.3437C52.6494 31.2489 51.7235 30.3965 50.6267 30.4422C49.6153 30.4839 48.5523 30.4919 47.4357 30.464C46.3389 30.4362 45.4269 31.3045 45.3991 32.3993C45.3713 33.4961 46.2396 34.4081 47.3343 34.4359Z",
    fill: "#347BFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0021 33.1661C60.2836 32.7945 61.44 32.3515 62.4772 31.8547C63.4647 31.3799 63.882 30.1917 63.4071 29.2022C62.9322 28.2147 61.744 27.7974 60.7565 28.2723C59.9022 28.6816 58.9504 29.0432 57.8934 29.3512C56.8403 29.6572 56.2343 30.7599 56.5403 31.813C56.8463 32.8661 57.949 33.4721 59.0021 33.1661Z",
    fill: "#347BFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4475 26.9747C69.3973 25.6197 70.0172 24.1752 70.359 22.7148C70.6093 21.6458 69.9437 20.5769 68.8767 20.3265C67.8097 20.0781 66.7388 20.7418 66.4904 21.8087C66.258 22.7982 65.8367 23.7758 65.193 24.6938C64.5651 25.5918 64.7817 26.8317 65.6798 27.4615C66.5779 28.0914 67.8197 27.8728 68.4475 26.9747Z",
    fill: "#347BFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6272 14.7429C68.747 12.6904 67.3681 10.9618 65.7308 9.83324C64.8268 9.20935 63.5889 9.43785 62.967 10.3399C62.3431 11.242 62.5716 12.4818 63.4737 13.1037C64.5367 13.8369 65.405 14.9794 65.9752 16.3106C66.4084 17.32 67.5787 17.7869 68.5861 17.3537C69.5934 16.9206 70.0603 15.7523 69.6272 14.7429Z",
    fill: "#347BFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1445 8.87687C46.2944 -3.297 64.9257 -2.51018 54.0791 8.87687H44.1445Z",
    fill: "#CADCF0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1445 11.9609C46.2944 24.1328 64.9257 23.348 54.0791 11.9609H44.1445Z",
    fill: "#CADCF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9654 12.425H57.2699C58.3666 12.425 59.2568 11.5349 59.2568 10.4381C59.2568 9.34131 58.3666 8.45117 57.2699 8.45117H43.9654C42.8706 8.45117 41.9785 9.34131 41.9785 10.4381C41.9785 11.5349 42.8706 12.425 43.9654 12.425Z",
    fill: "#347BFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.b975ff2dd8bb3dae784c4e2e336f4ff1.svg";
export { ForwardRef as ReactComponent };